import {isCountryNl} from './country.mjs';

// Translations which will be processed by processTranslations task in gulpfile.esm.js
export const translations = {
  GeoLocation: {
    'ADDRESS_NOT_FOUND': 'jobPosting.filter.geolocation.alert.ADDRESS_NOT_FOUND',
    'PERMISSION_DENIED': 'jobPosting.filter.geolocation.alert.PERMISSION_DENIED',
    'POSITION_UNAVAILABLE': 'jobPosting.filter.geolocation.alert.POSITION_UNAVAILABLE',
    'TIMEOUT': 'jobPosting.filter.geolocation.alert.TIMEOUT',
  },
};

class TranslationLoader {
  constructor() {
    this.currentLanguage = isCountryNl ? 'nl' : 'de';
    this.cache = {
      de: null,
      nl: null,
    };
    this.loadTranslations(this.currentLanguage);
  }

  /**
   * Load translations for a specific language
   * @param {string} language - Language code ('de' or 'nl')
   */
  async loadTranslations(language) {
    if (this.cache[language]) {
      return this.cache[language];
    }

    try {
      // Using dynamic import for the JSON files
      const translationsModule = await import(`../.generated/translations-${language}.json`);

      // Extract the actual translations object from the module
      this.cache[language] = translationsModule.default || {};
    } catch (error) {
      console.error(`Error loading translation file for ${language}:`, error);
    }
  }

  getTranslation(key) {
    if (this.cache[this.currentLanguage][key]) {
      return this.cache[this.currentLanguage][key];
    } else {
      return 'MISSING_TRANSLATION';
    }
  }
}

const defaultTransitionLoader = (new TranslationLoader());

/**
 * Get the translation for a key
 * @param {string} key - Translation key
 * @returns {string} - Translated string or "MISSING_TRANSLATION" if not found
 */
export function getTranslation(key) {
  return defaultTransitionLoader.getTranslation(key);
}
